import "./SideBar.style.css";

// React Bootstrap Icons
import { Basket2Fill, BoxSeam, CashStack, HouseFill } from "react-bootstrap-icons";

// React Router Dom
import { useNavigate } from "react-router-dom";

const SideBar = ({ type }) => {
    const navigate = useNavigate();

    return (
        <div id="side-bar" className="side-bar">
            <nav className="side-bar-nav">
                <ul className="side-bar-nav-list">

                    {type === "personal" ? (
                        <>
                            <li className="side-bar-nav-title">
                                <span>Personal</span>
                            </li>
                            <li className="side-bar-nav-item" onClick={() => navigate("/personal/dashboard")}>
                                <div className="side-bar-nav-link">
                                    <HouseFill />
                                    <span>Dashboard</span>
                                </div>
                            </li>
                            <li className="side-bar-nav-item" onClick={() => navigate("/personal/finances")}>
                                <div className="side-bar-nav-link">
                                    <CashStack />
                                    <span>Finances</span>
                                </div>
                            </li>

                            <li className="side-bar-nav-title">
                                <span>Reports</span>
                            </li>
                            <li className="side-bar-nav-item" onClick={() => navigate("/personal/finances/recap")}>
                                <div className="side-bar-nav-link">
                                    <CashStack />
                                    <span>Finances Recap</span>
                                </div>
                            </li>
                        </>
                    ) : (
                        <>
                            <li className="side-bar-nav-title">
                                <span>Business</span>
                            </li>
                            <li className="side-bar-nav-item" onClick={() => navigate("/business/dashboard")}>
                                <div className="side-bar-nav-link">
                                    <HouseFill />
                                    <span>Dashboard</span>
                                </div>
                            </li>
                            <li className="side-bar-nav-item" onClick={() => navigate("/business/finances")}>
                                <div className="side-bar-nav-link">
                                    <CashStack />
                                    <span>Finances</span>
                                </div>
                            </li>

                            <li className="side-bar-nav-title">
                                <span>Transactions</span>
                            </li>
                            <li className="side-bar-nav-item" onClick={() => navigate("/products")}>
                                <div className="side-bar-nav-link">
                                    <BoxSeam />
                                    <span>Products</span>
                                </div>
                            </li>
                            <li className="side-bar-nav-item" onClick={() => navigate("/orders")}>
                                <div className="side-bar-nav-link">
                                    <Basket2Fill />
                                    <span>Orders</span>
                                </div>
                            </li>

                            <li className="side-bar-nav-title">
                                <span>Reports</span>
                            </li>
                            <li className="side-bar-nav-item" onClick={() => navigate("/orders/recap")}>
                                <div className="side-bar-nav-link">
                                    <Basket2Fill />
                                    <span>Orders Recap</span>
                                </div>
                            </li>
                            <li className="side-bar-nav-item" onClick={() => navigate("/business/finances/recap")}>
                                <div className="side-bar-nav-link">
                                    <CashStack />
                                    <span>Finances Recap</span>
                                </div>
                            </li>
                        </>
                    )}

                </ul>
            </nav>
        </div>
    )
}

export default SideBar